module.exports = __webpack_public_path__ + "static/media/md-mail-unread.b20afe46.svg";